import { render, staticRenderFns } from "./GestioneInventario.vue?vue&type=template&id=09110c94&"
import script from "./GestioneInventario.vue?vue&type=script&lang=js&"
export * from "./GestioneInventario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports